import { faAnglesLeft, faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Carousel } from '@trendyol-js/react-carousel';
import React from 'react';
import { withSize, SizeMeProps } from 'react-sizeme';
import { CarouselButton, DashboardCarouselContainer } from './styled';

const DashboardCarousel = withSize()((props: {
    dataKey: string,
    itemWidth: number,
    children: any,
    infinite?: boolean,
    autoPlay?: boolean,
    autoPlayInterval?: number,
    slideCount?: number,
} & SizeMeProps) => {
    const { size } = props;
    const itemCount = Math.max(Math.floor((size.width || 1) / props.itemWidth), 1);
    const [isHover, setIsHover] = React.useState(false);

    const leftArrow = React.useMemo(() => {
        return (
            <CarouselButton id={props.dataKey + "_left"}><FontAwesomeIcon icon={faAnglesLeft} size={"1x"} /></CarouselButton>
        )
    }, []);

    const rightArrow = React.useMemo(() => {
        return (
            <CarouselButton id={props.dataKey + "_right"}><FontAwesomeIcon icon={faAnglesRight} size={"1x"} /></CarouselButton>
        )
    }, []);

    const performSlide = () => {
        const rightButton = document.getElementById(props.dataKey + "_right");
        if (!isHover) {
            rightButton?.click();
        }
    }

    React.useEffect(() => {
        let interval: NodeJS.Timeout;
        if (props.autoPlay && props.children.length > itemCount) {
            interval = setInterval(performSlide, props.autoPlayInterval || 5000);
        }

        return () => {
            if (interval) clearInterval(interval);
        }
    }, [isHover]);

    const onMouseEnter = React.useCallback(() => {
        setIsHover(true);
    }, [])

    const onMouseLeave = React.useCallback(() => {
        setIsHover(false);
    }, []);

    return (
        <DashboardCarouselContainer onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <Carousel infinite={props.infinite || props.autoPlay || false} transition={1} dynamic show={itemCount} slide={props.slideCount ?? itemCount} leftArrow={leftArrow} rightArrow={rightArrow}>
                {props.children}
            </Carousel>
        </DashboardCarouselContainer>
    )
})

export default DashboardCarousel;